import { render } from "./WebinarThankyou.vue?vue&type=template&id=72166823&scoped=true"
import script from "./WebinarThankyou.vue?vue&type=script&lang=js"
export * from "./WebinarThankyou.vue?vue&type=script&lang=js"

import "./WebinarThankyou.vue?vue&type=style&index=0&id=72166823&scoped=true&lang=css"

import exportComponent from "S:\\_Projects\\TRC4\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_5cff2737dde116e8fc1156af408c1302\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72166823"]])

export default __exports__